import client from './client'
import type { AdminUser, AdminUserDetail, UserSort, UserStatusFilter } from '@/types/users'
import type { PaginatedResponse } from '@/types/shared'

export interface ListUsersParams {
  search?: string
  status?: UserStatusFilter
  sort?: UserSort
  page?: number
  per_page?: number
}

export async function listUsers(
  params: ListUsersParams = {},
): Promise<PaginatedResponse<AdminUser>> {
  const { data } = await client.get<PaginatedResponse<AdminUser>>('/admin/users', { params })
  return data
}

export async function fetchUser(id: number): Promise<AdminUserDetail> {
  const { data } = await client.get<{ data: AdminUserDetail }>(`/admin/users/${id}`)
  return data.data
}

export async function verifyUserEmail(id: number): Promise<AdminUserDetail> {
  const { data } = await client.post<{ data: AdminUserDetail }>(`/admin/users/${id}/verify-email`)
  return data.data
}

export async function deactivateUser(id: number): Promise<AdminUserDetail> {
  const { data } = await client.post<{ data: AdminUserDetail }>(`/admin/users/${id}/deactivate`)
  return data.data
}
